import { importBootstrap5 } from "@cervval.js/client-html5-ui/src/lookAndFeel/bootstrap5";
import { ensureLoaded } from "@cervval.js/common/src/tools/object.tools";
import { App } from "../components/app/app";

// Import bootstrap5 styling
importBootstrap5();

// Load App component class so that it is known by the CustomElement registry
ensureLoaded(App);
